/* eslint-disable no-unused-vars */
import { initializeChat } from "../use_cases/InitializeChat";
import { sendUserFile } from "../use_cases/SendUserFile";
import { sendUserResponse } from "../use_cases/SendUserResponse";

const state = {
  isBotInitialized: false,
  conversation_id: "",
  chatState: "",
  messages: [],
  firstInteractionBot: false,
  callSimulator: false,
  chatRefresh: false,
  bot: {},
  captureList: [],
  captureVariables: {},
  locked: true,
  loading: false,
};

const mutations = {
  SET_CONVERSATION_ID(state, conversation_id) {
    state.conversation_id = conversation_id;
  },

  PUSH_MESSAGE(state, message) {
    state.messages.push(message);
  },

  RESET_MESSAGES(state) {
    state.messages = [];
  },

  CHANGE_STATE_INTERACTION_BOT(state) {
    state.firstInteractionBot = true;
  },

  async GET_DATA_CHAT_STORAGE(state) {
    var data = await JSON.parse(localStorage.getItem("chatData"));

    state.dataChatSession = data;
  },

  REFRESH_BOT(state) {
    state.chatRefresh = true;
  },

  OFF_REFRESH_BOT(state) {
    state.chatRefresh = false;
  },

  ACTIVE_SIMULATOR(state) {
    state.callSimulator = true;
  },

  INACTIVE_SIMULATOR(state) {
    state.callSimulator = false;
  },

  INSERT_CAPTURE_VALUE(state, object) {
    state.captureList.push(object);
  },

  INSERT_TO_CAPTURED_VARIABLES(state, object) {
    state.captureVariables = Object.assign(state.captureVariables, object);
  },
  SET_LOCK_STATUS(state, lock_state) {
    state.locked = lock_state;
  },
  SET_LOADING_STATUS(state, loading) {
    state.loading = loading;
  },
  SET_CONVERSATION_STATE(state, chat_state){
    state.chatState = chat_state;
  }
};

/* eslint-disable no-inner-declarations */
const actions = {
  async initializeChat({ commit }, { bot_id, data, simulator_mode }) {
    try {
      commit("RESET_MESSAGES");

      function commitChatState( state ) {
        commit("SET_CONVERSATION_STATE", state);
      }
      function commitChatMessage({ message_data }) {
        commit("PUSH_MESSAGE", message_data);
      }
      function commitConversationID({ conversation_id }) {
        commit("SET_CONVERSATION_ID", conversation_id);
      }
      function commitLockStatus({ current_lock }) {
        commit("SET_LOCK_STATUS", current_lock);
      }
      function commitLoadStatus({ loading }) {
        commit("SET_LOADING_STATUS", loading);
      }
      await initializeChat({
        commitChatState,
        commitChatMessage,
        commitConversationID,
        commitLockStatus,
        commitLoadStatus,
        bot_id,
        data,
        simulator_mode,
      });
      Promise.resolve();
    } catch (error) {
      Promise.reject(error);
    }
  },

  async sendMessage({ rootState, state }, { query }) {
    try {
      let data = await sendUserResponse({
        bot_id: rootState.bot_id,
        conversation_id: state.conversation_id,
        query,
      });

      data && data.result && data.result === "success"
        ? Promise.resolve(true)
        : Promise.resolve(false);
    } catch (error) {
      Promise.reject(error);
    }
  },

  async sendFile({ dispatch, rootState, state }, { file }) {
    async function sendMessage(query) {
      await dispatch("sendMessage", { query });
    }

    const newFile = await sendUserFile({
      bot_id: rootState.bot_id,
      conversation_id: state.conversation_id,
      file,
      sendMessage,
    });

    return newFile;
  },

  callFirstInteractionBot({ commit }) {
    return new Promise((resolve, reject) => {
      try {
        commit("CHANGE_STATE_INTERACTION_BOT");
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  },

  showSimulator(context) {
    context.commit("ACTIVE_SIMULATOR");
    localStorage.setItem('opened_chat', true);
  },
  hideSimulator(context) {
    context.commit("INACTIVE_SIMULATOR");
    localStorage.removeItem('opened_chat');
  },

  refreshSimulator({ commit }) {
    commit("REFRESH_BOT");
    commit("RESET_MESSAGES");
  },

  offRefreshSimulator({ commit }) {
    commit("OFF_REFRESH_BOT");
  },
};

export default { namespaced: true, state, mutations, actions };
